module.exports = "pegasus/assets/themelp1/product/104.png";